const DEMO_GUEST_NAME = "Asha Rao";

const demoEntries = [
  {
    projectionId: "demo-lake-weekend",
    entryType: "memory",
    title: "Weekend at the lake",
    summary: "A quiet morning, too many snacks, and one very proud cannonball.",
    sharedByName: "Meera",
    media: [
      {
        type: "photo",
        thumbnailUrl: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=720&q=80",
        displayUrl: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1800&q=88",
      },
      {
        type: "photo",
        thumbnailUrl: "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?auto=format&fit=crop&w=720&q=80",
        displayUrl: "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?auto=format&fit=crop&w=1800&q=88",
      },
      {
        type: "photo",
        thumbnailUrl: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=720&q=80",
        displayUrl: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1800&q=88",
      },
      {
        type: "photo",
        thumbnailUrl: "https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=720&q=80",
        displayUrl: "https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=1800&q=88",
      },
    ],
  },
  {
    projectionId: "demo-recital",
    entryType: "milestone",
    title: "Asha's first recital",
    summary: "She looked for the grandparents before taking her bow.",
    sharedByName: "Vamsi",
    media: [
      {
        type: "photo",
        thumbnailUrl: "https://images.unsplash.com/photo-1516280440614-37939bbacd81?auto=format&fit=crop&w=720&q=80",
        displayUrl: "https://images.unsplash.com/photo-1516280440614-37939bbacd81?auto=format&fit=crop&w=1800&q=88",
      },
    ],
  },
];

const demoInteractionsByEntry = new Map([
  [
    "demo-lake-weekend",
    [
      {
        interactionId: "demo-lake-heart",
        kind: "reaction",
        authorName: "Grandma Lakshmi",
        emoji: "❤️",
        createdAt: "2026-06-20T15:10:00.000Z",
        isMine: false,
      },
      {
        interactionId: "demo-lake-comment",
        kind: "comment",
        authorName: "Grandma Lakshmi",
        text: "That cannonball photo is going on the fridge.",
        createdAt: "2026-06-20T15:12:00.000Z",
        isMine: false,
      },
    ],
  ],
  [
    "demo-recital",
    [
      {
        interactionId: "demo-recital-reaction",
        kind: "reaction",
        authorName: DEMO_GUEST_NAME,
        emoji: "🙌",
        createdAt: "2026-06-20T16:01:00.000Z",
        isMine: true,
      },
      {
        interactionId: "demo-recital-comment",
        kind: "comment",
        authorName: "Grandpa Rao",
        text: "We were so proud watching her bow.",
        createdAt: "2026-06-20T16:03:00.000Z",
        isMine: false,
      },
    ],
  ],
]);

export function demoEnabled() {
  return import.meta.env.DEV && new URLSearchParams(window.location.search).has("demo");
}

export function demoFeed() {
  return { entries: demoEntries };
}

export function demoEntry(projectionId) {
  return {
    entry: demoEntries.find((entry) => entry.projectionId === projectionId) || null,
  };
}

export function demoInteractions(projectionId) {
  return {
    interactions: [...(demoInteractionsByEntry.get(projectionId) || [])],
  };
}

export function demoAddComment(projectionId, text) {
  const existing = demoInteractionsByEntry.get(projectionId) || [];
  demoInteractionsByEntry.set(projectionId, [
    ...existing,
    {
      interactionId: `demo-comment-${Date.now()}`,
      kind: "comment",
      authorName: DEMO_GUEST_NAME,
      text: text.trim(),
      createdAt: new Date().toISOString(),
      isMine: true,
    },
  ]);
  return { success: true };
}

export function demoDeleteComment(projectionId, interactionId) {
  const existing = demoInteractionsByEntry.get(projectionId) || [];
  demoInteractionsByEntry.set(
    projectionId,
    existing.filter(
      (item) => !(item.kind === "comment" && item.isMine && item.interactionId === interactionId),
    ),
  );
  return { success: true };
}

export function demoSetReaction(projectionId, emoji) {
  const existing = (demoInteractionsByEntry.get(projectionId) || []).filter(
    (item) => !(item.kind === "reaction" && item.isMine && item.emoji === emoji),
  );
  demoInteractionsByEntry.set(projectionId, [
    ...existing,
    {
      interactionId: `demo-reaction-${emoji}`,
      kind: "reaction",
      authorName: DEMO_GUEST_NAME,
      emoji,
      createdAt: new Date().toISOString(),
      isMine: true,
    },
  ]);
  return { success: true };
}

export function demoDeleteReaction(projectionId, emoji) {
  const existing = demoInteractionsByEntry.get(projectionId) || [];
  demoInteractionsByEntry.set(
    projectionId,
    existing.filter(
      (item) => !(item.kind === "reaction" && item.isMine && item.emoji === emoji),
    ),
  );
  return { success: true };
}
